<script>
export const group = 'Full'
</script>

<script setup>
import ToFullTopLeft from './transitions/energetic_frequencies/ToFullTopLeft.vue'
import backgroundImage from '~/assets/images/olympic_medals_background.png'
import goldMedal from '~/assets/images/olympic_medals_gold.png'
import silverMedal from '~/assets/images/olympic_medals_silver.png'
import bronzeMedal from '~/assets/images/olympic_medals_bronze.png'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const goldCount = computed(() => item.properties.goldCount)
const silverCount = computed(() => item.properties.silverCount)
const bronzeCount = computed(() => item.properties.bronzeCount)

const goldStack = ref(null)
const silverStack = ref(null)
const bronzeStack = ref(null)

const goldNumber = ref(null)
const silverNumber = ref(null)
const bronzeNumber = ref(null)

onMounted(() => {
  const tl = gsapTimeline({ name: 'Olympic Medals' })

  const stacks = [goldStack.value, silverStack.value, bronzeStack.value]
  const numbers = [goldNumber.value, silverNumber.value, bronzeNumber.value]

  stacks.forEach((stack, index) => {
    if (stack) {
      const medals = stack.querySelectorAll('.medal')
      tl.from(
        medals,
        {
          duration: frames(6),
          scale: 0,
          opacity: 0,
          stagger: frames(2),
          ease: 'back.out(1.7)',
        },
        frames(25 + index * 8)
      )

      tl.from(
        numbers[index],
        {
          duration: frames(8),
          scale: 0,
          opacity: 0,
          ease: 'back.out(1.7)',
        },
        frames(25 + index * 8)
      )
    }
  })
})
</script>

<template>
  <ToFullTopLeft>
    <div class="size-full flex flex-col items-center justify-end pb-[25rem]" :style="{ backgroundImage: `url(${backgroundImage})` }">
      <div class="flex items-end gap-4">
        <div class="flex flex-col items-center">
          <div ref="goldStack" class="relative mb-8 w-[320px]">
            <img
              v-for="i in goldCount"
              :key="`gold-${i}`"
              :src="goldMedal"
              class="medal absolute left-0 w-full drop-shadow-2xl"
              :style="{
                bottom: `${(i - 1) * 40}px`,
              }"
            />
          </div>
          <div ref="goldNumber" class="flex items-center justify-center w-36 h-36 rounded-full border-8 border-yellow-500">
            <span class="text-8xl font-bold text-white">{{ goldCount }}</span>
          </div>
        </div>
        <div class="flex flex-col items-center">
          <div ref="silverStack" class="relative mb-8 w-[320px]">
            <img
              v-for="i in silverCount"
              :key="`silver-${i}`"
              :src="silverMedal"
              class="medal absolute left-0 w-full drop-shadow-2xl"
              :style="{
                bottom: `${(i - 1) * 40}px`,
              }"
            />
          </div>
          <div ref="silverNumber" class="flex items-center justify-center w-36 h-36 rounded-full border-8 border-yellow-500">
            <span class="text-8xl font-bold text-white">{{ silverCount }}</span>
          </div>
        </div>
        <div class="flex flex-col items-center">
          <div ref="bronzeStack" class="relative mb-8 w-[320px]">
            <img
              v-for="i in bronzeCount"
              :key="`bronze-${i}`"
              :src="bronzeMedal"
              class="medal absolute left-0 w-full drop-shadow-2xl"
              :style="{
                bottom: `${(i - 1) * 40}px`,
              }"
            />
          </div>
          <div ref="bronzeNumber" class="flex items-center justify-center w-36 h-36 rounded-full border-8 border-yellow-500">
            <span class="text-8xl font-bold text-white">{{ bronzeCount }}</span>
          </div>
        </div>
      </div>
    </div>
  </ToFullTopLeft>
</template>
